import React, { FC, useMemo } from 'react';
import { Box } from '@mui/material';

import { PlanType } from 'src/pages/constants';
import SubscriptionDurationButtons from '../subscription-duration-buttons';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setSelectedPlanId } from 'src/store/signup';
import { EVENTS, trackSignupFunnel } from 'src/util/track';
import GiftEligibilityCard from '../gift-with-purchase/GiftEligibilityCard';

interface DurationProps {
  planType: PlanType;
  isTwelveMonthParam?: boolean;
}

const SubscriptionDurationContainer: FC<DurationProps> = ({
  planType = 'standard',
  isTwelveMonthParam = false,
}) => {
  const dispatch = useAppDispatch();
  const isStandardPlan = planType === 'standard';
  const { availablePlans: allAvailablePlans, selectedPlanId } = useAppSelector(
    state => state.signUp
  );

  const handleSelect = (planId: string) => {
    if (planId === selectedPlanId) {
      return;
    }

    const selectedPlan = allAvailablePlans.find(plan => plan.id === planId);

    trackSignupFunnel(EVENTS.signupPlanSelected, {
      plan_type: planType,
      selected_plan_id: planId,
      selected_plan_interval: selectedPlan?.interval,
      selected_plan_interval_count: selectedPlan?.intervalCount,
      selection_surface: 'subscription_duration_buttons',
    });
    dispatch(setSelectedPlanId(planId));
  };

  const availablePlans = useMemo(() => {
    if (isTwelveMonthParam && isStandardPlan) {
      return allAvailablePlans.filter(
        plan => plan.id !== 'Standard Plan - 1 Month'
      );
    }
    if (!isTwelveMonthParam) {
      return allAvailablePlans.filter(plan => !plan.id.includes('12 Month'));
    }
    return allAvailablePlans;
  }, [allAvailablePlans, isTwelveMonthParam, isStandardPlan]);

  return (
    <Box
      my={'16px'}
      width={'100%'}
      textAlign={'center'}
      fontSize={'20px'}
      fontWeight={800}>
      Our billing cycles are flexible
      <Box mt={'16px'}>
        <SubscriptionDurationButtons
          availablePlans={availablePlans}
          selected={selectedPlanId}
          onSelect={handleSelect}
          variant={!isStandardPlan ? 'dark' : 'light'}
        />
      </Box>
      {isStandardPlan && <GiftEligibilityCard />}
    </Box>
  );
};

export default SubscriptionDurationContainer;
